<template>
  <div class="examinationPaperInformation">
      <div class="page-module">
          <div class="examinationPaperInformation-content">
              <div class="title">
                  <p>{{msg.subject}}</p>
              </div>
              <div class="msg">
                <div class="img">
                    <img v-lazy="msg.coverurl" :alt="msg.subject">
                </div>
                <div class="text-msg">
                    <div class="msg-table">
                        <p><span>答题数目：</span>{{msg.quescount}}道</p>
                        <p><span>试卷总分：</span>{{msg.examtotalscore}}分</p>
                        <p><span>考试时长：</span>{{msg.examlength == 0 ? '不限制' : msg.examlength + '分钟'}}</p>
                        <p><span>可考次数：</span>{{msg.examcount==0?'不限制': msg.examcount+'次'}}</p>
                        <p><span>参与人数：</span>{{msg.usecount}}人参与过</p>
                        <p><span>提供机构：</span>{{msg.hostname}}</p>
                    </div>
                    <div>
                        <el-button type="primary" v-if="msg.status == 0" @click="startTheExam()">开始考试</el-button>
                        <el-button type="primary" v-if="msg.status == 1" @click="continuingExamination(msg.userexaminnerid)">继续考试</el-button>
                        <el-button type="primary" v-if="msg.status == 11" @click="startTheExam()">重新考试</el-button>
                        <el-button type="primary" plain v-if="msg.status == 11 || msg.status == 10" @click="goRouter(msg.userexaminnerid)">查看成绩</el-button>
                        <el-button type="primary" plain v-if="msg.isshowanswer == 1" @click="continuingExamination(msg.userexaminnerid)">查看答案解析</el-button>
                    </div>
                </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import {getExampaperDetail, updateStartExam} from 'api/questionbank'
export default {
  name: 'examinationPaperInformation',
  data () {
    return {
        api: {
            bankid: this.$route.query.bankid,   // 题库id
            taskid: this.$route.query.taskid || this.$route.query.taskid == '' ? this.$route.query.taskid : 0     // 任务id
        },
        msg: {  // 试卷内容
            subject: "", //试卷标题
            coverurl: "", //试卷封面
            examcount: "", //考试次数
            quescount: "", //答题数目
            examtotalscore: "", //试卷分数 
            examlength: "", //考试时长
            usecount: "", //参与人数
            isexam: "", //是否考试过 0否 1是 
            iscanexam: "", //能否重新考试 0否 1是 
            status: "", //当前考试得状态 0 开始考试  1 继续考试 10 已考 11 重考
            userexaminnerid: "", //当前考试id
            hostname: "" // 提供机构
        }
    }
  },
  mounted () {
      // 获取试卷信息
      this.getExampaperDetail()
  },
  methods: {
      getExampaperDetail() {    // 获取试卷信息
        this.setLoading(true)
        getExampaperDetail({
            data: this.api,
            success: data => {
                this.setLoading(false)
                this.msg = data.data
                // 初始化导航栏名称
                this.$parent.initTestPaperNavTitle(this.msg.subject)
            },
            error: data => {
                this.setLoading(false)
                this.$message.error(data.msg)
            }
        })
      },
      startTheExam() {  // 调用开始考试接口 获取相关考试信息
        this.setLoading(true)
        updateStartExam({
            data: {assetinnerid: this.api.bankid, taskid: this.api.taskid, examid: ''},
            success: data => {
                this.setLoading(false)
                this.$router.push({name: 'ExaminationInterface', query: {'examid': data.data, 'bankid': this.$route.query.bankid}})
            },
            error: data => {
                this.setLoading(false)
                this.$message.error(data.msg)
            }
        })
      },
      continuingExamination(userexaminnerid) {// 继续考试
        this.$router.push({name: 'ExaminationInterface', query: {'examid': userexaminnerid, 'bankid': this.$route.query.bankid}})
      },
      goRouter(userexaminnerid) {    // 查看成绩
        this.$router.push({name: 'ViewingResults', query: {'examid': userexaminnerid, 'bankid': this.$route.query.bankid}})
       },
      ...mapActions(['setLoading'])
  },
  filters: {},
  watch: {},
  computed: {},
  components: {}
}
</script>

<style lang="scss" type="text/scss" scope>
.examinationPaperInformation {
    .examinationPaperInformation-content {
        padding: 0 20px;
        background: #fff;

        .title {
            border-bottom: dashed 1px #E5E5E5;
            p {
                padding: 40px 0;
                text-align: center;
                font-size: 24px;
            }
        }
        .msg {
            padding-top: 50px;
            padding-bottom: 211px;
            overflow: hidden;

            .img {
                float: left;
                width: 460px;
                height: 260px;
                
                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 6px;
                }
            }

            .text-msg {
                float: right;
                width: 619px;

                .msg-table {
                    padding-bottom: 10px;
                    border-bottom: dashed 1px #E5E5E5;
                    overflow: hidden;
                    
                    p {
                        float: left;
                        margin-bottom: 20px;
                        color: #303133;
                        span {
                            color: #999;
                        }

                        &:nth-child(odd) {
                            width: 40%;
                        }
                        &:nth-child(even) {
                            width: 60%;
                        }
                    }
                }
                .el-button {
                    margin-left: 0;
                    margin-right: 24px;
                    margin-top: 30px;
                }
            }
        }
    }
}
</style>